// src/components/common/ReportUsageModal.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = "https://ims.holdthechild.net";

const ReportUsageModal = ({ closeModal, item }) => {
    const [quantityUsed, setQuantityUsed] = useState(1);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const token = localStorage.getItem('token');

        const data = {
            quantityUsed: Number(quantityUsed)
        };

        try {
            await axios.post(`${API_URL}/api/issued-items/report-usage/${item._id}`, data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success(`Successfully reported usage of ${quantityUsed} ${item.itemId.unitOfMeasure}.`);
            closeModal();
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
            toast.error(`Error: ${errorMessage}`);
        } finally {
            setLoading(false);
        }
    };

    const remaining = item.quantityIssued - item.quantityConsumed;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-lg">
                <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4">
                    <h2 className="text-2xl font-bold text-orange-600">Report Usage for "{item.itemId.name}"</h2>
                    <button type="button" onClick={closeModal} className="text-3xl text-gray-400 hover:text-red-500 font-light">&times;</button>
                </div>

                <div className="space-y-4">
                    <div className="p-4 bg-gray-50 rounded-md">
                        <p className="font-semibold">Quantity Remaining: <span className="text-green-600">{remaining} {item.itemId.unitOfMeasure}</span></p>
                    </div>

                    <div>
                        <label className="block mb-1 font-medium text-gray-700">Quantity to Report as Used</label>
                        <input
                            type="number"
                            value={quantityUsed}
                            onChange={(e) => setQuantityUsed(e.target.value)}
                            min="1"
                            max={remaining}
                            className="w-full border rounded-md px-3 py-2"
                            required
                        />
                    </div>
                </div>

                <div className="flex justify-end gap-4 mt-8 pt-4 border-t border-gray-200">
                    <button type="button" onClick={closeModal} className="px-5 py-2 rounded-md border border-gray-300 hover:bg-gray-50" disabled={loading}>Cancel</button>
                    <button type="submit" className="px-5 py-2 rounded-md bg-orange-600 text-white hover:bg-orange-700 disabled:opacity-50" disabled={loading || quantityUsed > remaining}>
                        {loading ? "Reporting..." : "Report Usage"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ReportUsageModal;